import React, { useRef, useEffect } from 'react'
import { Text } from 'components/forms'
import Button from 'components/Button'
import Divider from 'components/Divider'
import style from './auth.module.scss'
import { withTranslation } from 'react-i18next'
import AuthContainer from './AuthContainer'

const ConfirmSignIn = props => {
	const formApi = useRef(null)
	const { t, authProps } = props


	const getApi = api => {
		formApi.current = api
	}

	useEffect(() => {
		if(authProps.error && formApi.current) {
			switch(authProps.error) {
				case 'Invalid code received for user':
					formApi.current.setError('code', t('auth_screen.error.invalid_code'))
					break
				case 'Network error':
					formApi.current.setError('code', t('auth_screen.error.network'))
					break
				default:
					formApi.current.setError('code', t('auth_screen.error.default'))
					break
			}
		}
	}, [authProps.error])

	const handleMfa = async ({ code }) => {
		await authProps.submitForm({
			confirmation_code: code
		})
	}

	return (
		<AuthContainer getApi={getApi} className={style.form} onSubmit={handleMfa}>
			{({ formState: { errors } }) => (
				<>
					<p>{t('auth_screen.message.complete_mfa')}</p>
					<Divider height={20}/>
					<Text
						errors={errors}
						errorClass={style.formInputError}
						field='code'
						placeholder={t('auth_screen.form.mfa_code')}
						usePlaceholder
						validate={v => (v ? null : t('auth_screen.error.mfa_code_required'))}
						validateOnChange
						autoFocus
					/>
					<Divider height={20}/>
					<Button
						status='active'
						text={t('common.buttons.confirm')}
						type='submit'
						{...authProps.isPending && { loading: true }}
					/>
					<div className={style.linkButton} onClick={authProps.toSignIn}>
						{t('auth_screen.button.go_back')}
					</div>
				</>
			)}
		</AuthContainer>
	)
}

export default withTranslation()(ConfirmSignIn)
